module.exports = __webpack_public_path__ + "img/Prong Too Long.832888a5.png";